<template>
        <v-dialog
      v-model="dialog" persistent
      width="800"
      aria-labelledby="edit-dialog-title"
      >
       <v-card>
        <v-card-title id="edit-dialog-title" class="headline">
          Edit <span>{{transMessage}}</span>
          <v-btn class="closebtn" fab small @click="setClose" aria-label="Chiudi"><v-icon dark aria-hidden="true">close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
                
                  <v-textarea 
                  outlined
                  rows="5"
          v-model="content" label="Edit - enter one line for each translation"></v-textarea>
                
        </v-card-text>
        <v-card-actions class="mt-0 pt-0">
          <v-container class="mt-0 pt-0">
          <v-btn color="primary" @click="save()">save</v-btn>
          </v-container>
        </v-card-actions>
       </v-card>
      </v-dialog>

</template>

<script>
import ApiAuth from '@/services/ApiAuth';
export default {
  mounted() {
    this.content = this.editOptions.values.length > 0 ? this.editOptions.values.join("\n") : this.editOptions.values;
    this.literal = this.editOptions.literal;
    this.transMessage = (this.editOptions.isNewTranslation != "undefined" && this.editOptions.isNewTranslation == true) ? " - Create a new translation in italian" : ""
    console.log("qui",this.TransMessage);
  },
  props:["editOptions"],
  data() {
    return {
      dialog:true,
      content:"",
      transMessage:""
    }
  },
  computed: {
  },
  methods:{
    save() {
      ApiAuth()
      .post("/api/edukanji/edit/save/ita",{content:this.content,literal:this.literal})
      .then((result) => {
        if(result.data.result == true) {
          
          this.$emit("close",{updateItem:'ita',updateValue:result.data.values});
        }
      }).catch((error)=> {
          //
      }) 
      
    },
    setClose() {
      this.$emit("close");
    }

  }
}
</script>

<style scoped>
.closebtn {
  position:absolute;
  right:8px;
}
</style>